import React from 'react';
import { SvgIcon } from '@mui/material';

const WarningAiIcon = props => {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 6.00006V10.0001M2.37891 12.1999C1.46947 13.775 1.01489 14.5629 1.08281 15.2092C1.14206 15.7729 1.43792 16.2851 1.89648 16.6182C2.42204 17.0001 3.3309 17.0001 5.14853 17.0001H14.8515C16.6691 17.0001 17.5778 17.0001 18.1034 16.6182C18.5619 16.2851 18.8579 15.7729 18.9172 15.2092C18.9851 14.5629 18.5307 13.775 17.6212 12.1999L12.7715 3.79986C11.8621 2.22468 11.4071 1.43722 10.8135 1.17291C10.2957 0.942364 9.70401 0.942364 9.18619 1.17291C8.59278 1.43711 8.13814 2.22458 7.22946 3.79845L2.37891 12.1999ZM10.0508 13.0001V13.1001L9.9502 13.1003V13.0001H10.0508Z"
          stroke="#7174AC"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default WarningAiIcon;
